import type { TRegUser } from 'types'

type NewsletterConsent = {
  marketing_authorization?: boolean
  channels_preferences?: string[]
}

export const hasNewsletterSubscription = (
  sfUser: Partial<TRegUser> | boolean | undefined
) =>
  !!sfUser &&
  typeof sfUser !== 'boolean' &&
  !!sfUser.marketing_authorization &&
  !!sfUser.channels_preferences?.includes('Email')

// Registration mirrors the server: marketing consent with no channel selected is
// filled with Email before the consents are mapped, so it subscribes as well.
export const givesNewsletterConsent = (form: NewsletterConsent) =>
  !!form.marketing_authorization &&
  (!form.channels_preferences?.length ||
    form.channels_preferences.includes('Email'))
